import axiosInstance from '../../../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../../../env'
import type { LumpsumRecommendationActionType } from '../../api/common.types'
import type { LumpsumIdealPlanRecommendationApiResponse } from './idealRecommendation.types'
import type { LumpsumAllocationPlanRecommendationApiResponse } from './allocationRecommendation.types'
import type { LumpsumRebalancePlanRecommendationApiResponse } from './rebalanceRecommendation.types'

const LUMPSUM_REBALANCE_PLAN_RECOMMENDATION_URL = `${mobileBackendUrl}/v2/portfolio/rebalance-plan/lumpsum`
const LUMPSUM_ALLOCATION_PLAN_RECOMMENDATION_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/lumpsum`
const LUMPSUM_IDEAL_PLAN_RECOMMENDATION_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/ideal`

export async function fetchLumpsumAllocationPlanRecommendation(
  isin: string,
  recommendationAction: LumpsumRecommendationActionType
): Promise<LumpsumAllocationPlanRecommendationApiResponse> {
  const recommendationUrl = `${LUMPSUM_ALLOCATION_PLAN_RECOMMENDATION_URL}/${encodeURIComponent(isin)}`
  const response = await axiosInstance.get<LumpsumAllocationPlanRecommendationApiResponse>(recommendationUrl, {
    params: {
      recommendationAction
    }
  })
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum allocation plan recommendation')
  }
  return response.data
}

export async function fetchLumpsumRebalancePlanRecommendation(
  isin: string,
  recommendationAction: LumpsumRecommendationActionType
): Promise<LumpsumRebalancePlanRecommendationApiResponse> {
  const recommendationUrl = `${LUMPSUM_REBALANCE_PLAN_RECOMMENDATION_URL}/${encodeURIComponent(isin)}`
  const response = await axiosInstance.get<LumpsumRebalancePlanRecommendationApiResponse>(recommendationUrl, {
    params: {
      recommendationAction
    }
  })
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum rebalance plan recommendation')
  }
  return response.data
}

export async function fetchLumpsumIdealPlanRecommendation(
  isin: string
): Promise<LumpsumIdealPlanRecommendationApiResponse> {
  const recommendationUrl = `${LUMPSUM_IDEAL_PLAN_RECOMMENDATION_URL}/${encodeURIComponent(isin)}`
  const response = await axiosInstance.get<LumpsumIdealPlanRecommendationApiResponse>(recommendationUrl)
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum ideal plan recommendation')
  }
  return response.data
}
